import { render, staticRenderFns } from "./PaperlessNG.vue?vue&type=template&id=10a820a0&scoped=true&"
import script from "./PaperlessNG.vue?vue&type=script&lang=js&"
export * from "./PaperlessNG.vue?vue&type=script&lang=js&"
import style0 from "./PaperlessNG.vue?vue&type=style&index=0&id=10a820a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a820a0",
  null
  
)

export default component.exports